/**
 * 临时材料采购发票识别的数据规则：申请人先核对 AI 提取内容，再进入现有 CEO 审批。
 * 手填数据优先；识别材料逐行保留，避免采购发票漏行或覆盖人工修正。
 */
const IMAGE_EXT = /\.(jpe?g|png|webp|heic|heif)$/i;
const PDF_EXT = /\.pdf$/i;
const MAX_BYTES = 25 * 1024 * 1024;
const MAX_PAGES = 10;

/** 校验单张发票可接受的页数、格式和大小，与后端账单图像处理规则保持一致。 */
export function validateMaterialInvoiceFiles(files) {
  if (!files?.length || files.length > MAX_PAGES) return "数量限 1–10 张照片，或一个 PDF。";
  const pdfs = files.filter((file) => PDF_EXT.test(file.name || ""));
  if (files.some((file) => !PDF_EXT.test(file.name || "") && !IMAGE_EXT.test(file.name || ""))) return "只支持照片或 PDF。";
  if (pdfs.length && (pdfs.length !== 1 || files.length !== 1)) return "一个 PDF 已包含整张发票，请勿与其他文件混合。";
  if (files.some((file) => !file.size) || files.reduce((total, file) => total + Number(file.size || 0), 0) > MAX_BYTES) return "文件不能为空，合计不能超过 25 MB。";
  return "";
}

function emptyItem(item) {
  return !["name", "brand", "model", "specification", "unit", "unitPrice"].some((key) => String(item?.[key] || "").trim());
}

/** 中文需求说明：识别结果只补空白表头；保留手填行，并把发票明细逐行追加给申请人核对。 */
export function mergeMaterialInvoiceRecognition(current, recognition) {
  const next = { ...current };
  if (!String(current.supplierName || "").trim() && recognition.supplierName) next.supplierName = recognition.supplierName;

  const details = { ...(current.sourceInvoiceDetails || {}) };
  ["invoiceNo", "invoiceDate", "currency", "invoiceTotal"].forEach((key) => {
    if (!String(details[key] || "").trim() && recognition[key]) details[key] = String(recognition[key]);
  });
  next.sourceInvoiceDetails = details;

  const recognizedItems = (recognition.items || []).map((item) => ({
    name: item.name || "", brand: item.brand || "", model: item.model || "", specification: item.specification || "",
    quantity: item.quantity == null ? "" : String(item.quantity), unit: item.unit || "", unitPrice: item.unitPrice == null ? "" : String(item.unitPrice),
  }));
  const existingItems = current.items?.length ? current.items.map((item) => ({ ...item })) : [];
  if (existingItems.length && emptyItem(existingItems[0]) && String(existingItems[0].quantity || "1") === "1" && recognizedItems.length) {
    existingItems.splice(0, 1, recognizedItems.shift());
  }
  next.items = [...existingItems, ...recognizedItems];
  return next;
}
